







































































import ReviewListPaginated from '@/components/ReviewListPaginated.vue'
import EstablishmentPlatforms from '@/components/EstablishmentPlatforms.vue'
import EstablishmentDetail from '@/components/EstablishmentDetail.vue'
import EstablishmentCard from '@/components/EstablishmentCard.vue'
import EstablishmentListFilterTeam from '@/components/EstablishmentListFilterTeam.vue'
import EstablishmentPictures from '@/components/EstablishmentPictures.vue'
import EtherPad from '@/components/Etherpad.vue'
import StatsTeam from '@/components/StatsTeam.vue'
import TextForNextReport from '@/components/TextForNextReport.vue'
import EstablishmentModal from '@/components/EstablishmentModal.vue'
import utils from '@/utils.js'
import gql from '@/gqlService.coffee'

export default {
    name: 'establishment',
    components: {
        ReviewListPaginated
        EstablishmentListFilterTeam
        EstablishmentDetail
        EstablishmentPlatforms
        EstablishmentPictures
        EstablishmentCard
        EtherPad
        TextForNextReport
        EstablishmentModal
    }
    data: ()->
        padHeight: (window.innerHeight-253)+ "px"
        loadReviews: false
        establishment: new gql.DataHolder({
                "model": "establishment",
                "fields": "uid name logo main_picture nb_negative nb_positive response_time website image_set{uid,picture,establishment{uid}} page_reseau_public page_reseau_public_2",
                "autoload": false,
                "pk": "id",
                "reload_on_models":['estblishment_picture_set', 'establishment_set'] 
            })
    computed:{
        computed_filters: ()->
            vm = @
            {
                establishment: {uid: vm.$store.state.selected_establishment_uid}
            }
        review_filter: ()->
            vm = @
            #if vm.$store.state.selected_establishment_uid?
                #vm.loadReviews = true
                #return "establishment:\"#{vm.$store.state.selected_establishment_uid}\""
            return null
    }
    methods: {}
    mounted: ()->
        vm = this
    beforeDestroy: ()->
        vm = this
    watch:
        "$store.state.selected_establishment_uid": (newV, oldV)->
            vm = this
            if newV? and newV != oldV
                vm.establishment.query({id: newV})
        
}
